"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var venuesAdapter = _a.venuesAdapter;
    return ({
        getAll: function () {
            return venuesAdapter.getAll();
        },
        getVenuesSlotsInTimeRange: function (startDate, endDate) {
            if (!startDate) {
                throw new Error('Invalid parameter `startDate`');
            }
            if (!endDate) {
                throw new Error('Invalid parameter `endDate`');
            }
            return venuesAdapter.getVenuesSlotsInTimeRange(startDate, endDate);
        }
    });
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmVudWVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlcnZpY2VzL3ZlbnVlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQWNBLG1CQUFlLFVBQUMsRUFBNkM7UUFBM0MsZ0NBQWE7SUFBbUMsT0FBQSxDQUFDO1FBQ2pFLE1BQU07WUFDSixPQUFPLGFBQWEsQ0FBQyxNQUFNLEVBQUUsQ0FBQztRQUNoQyxDQUFDO1FBQ0QseUJBQXlCLFlBQUMsU0FBUyxFQUFFLE9BQU87WUFDMUMsSUFBSSxDQUFDLFNBQVMsRUFBRTtnQkFDZCxNQUFNLElBQUksS0FBSyxDQUFDLCtCQUErQixDQUFDLENBQUM7YUFDbEQ7WUFDRCxJQUFJLENBQUMsT0FBTyxFQUFFO2dCQUNaLE1BQU0sSUFBSSxLQUFLLENBQUMsNkJBQTZCLENBQUMsQ0FBQzthQUNoRDtZQUNELE9BQU8sYUFBYSxDQUFDLHlCQUF5QixDQUFDLFNBQVMsRUFBRSxPQUFPLENBQUMsQ0FBQztRQUNyRSxDQUFDO0tBQ2dCLENBQUE7QUFiK0MsQ0FhL0MsRUFBQyJ9


//////////////////
// WEBPACK FOOTER
// ../@core/dist/services/venues.js
// module id = 879
// module chunks = 0